import { Injectable } from "@angular/core";

import { ImageSearchCriteria } from "@models/ImageSearchCriteria";

import { PlantsService } from "./plants.service";

@Injectable()
export class ImageSearchResolver {
  constructor(private ps: PlantsService) {}

  async resolve(): Promise<ImageSearchCriteria> {
    const criteria = await this.ps.getImageSearchCriteria(
      new ImageSearchCriteria(),
      new ImageSearchCriteria()
    );
    return criteria;
  }
}
